import React from "react";
import "./ErrorPage.css";
import { ErrorOutline } from "@mui/icons-material";

function ErrorPage() {
  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-icon">
          <ErrorOutline fontSize="inherit" />
        </div>
        <h1 className="error-title">404 ERROR</h1>
        <p className="error-message">
          The page you are looking for doesn't exist, please verify the URL
        </p>
        <a className="back-button" href="/">
          Back To Home
        </a>
      </div>
    </div>
  );
}

export default ErrorPage;
